import { render, staticRenderFns } from "./BaseLoginPhone.vue?vue&type=template&id=74741af4&scoped=true&"
import script from "./BaseLoginPhone.vue?vue&type=script&lang=js&"
export * from "./BaseLoginPhone.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoginPhone.vue?vue&type=style&index=0&id=74741af4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74741af4",
  null
  
)

export default component.exports